import { render } from "./DocumentsGeneral..vue?vue&type=template&id=913a9340"
import script from "./DocumentsGeneral..vue?vue&type=script&lang=js"
export * from "./DocumentsGeneral..vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__